function savedDesignsInit() {
	let umoq = window.UnitMOQ;
	let umoqSession = umoq?.beta?.session;
	let prodObj = $('.product')?.data('obj');
	let productId = prodObj?.productId;
	let urlParams = new URLSearchParams(window.location.search);
	let designId = urlParams.get('design');
	let savedDesigns = umoqSession?.getDesigns();
	const customerId = prodObj?.customerId;
	if (customerId) {
		umoq?.setDesignerId(customerId);
	}

	/**
	 * Helper for loading UnitMOQ products and avoiding the same product being loaded twice.
	 * In most cases, that would be undesiredable. There is an edge where a customer may be attempting
	 * to reload a variant after they have modified it. However, the current UI does not support this
	 * interaction at the moment. - JRH (03/23/26)
	 */
	let curUmoqDesignIdOrSku = null;
	const loadUnitMoqProductPreview = (designIdOrSku) => {
		console.group('loadUnitMoqProductPreview', {designIdOrSku, curUmoqDesignIdOrSku})
		if (curUmoqDesignIdOrSku === designIdOrSku) {
			console.log('Requested designIdOrSku already loaded');
			console.groupEnd();
			return; // Already loaded.
		}

		curUmoqDesignIdOrSku = designIdOrSku;
		umoq.loadPreview(curUmoqDesignIdOrSku);

		console.groupEnd();
	}

	const handleDeeplinkingToDesign = () => {
		urlParams = new URLSearchParams(window.location.search);
		designId = urlParams.get('design');
		const variantId = urlParams.get('variant');
		if (!variantId && designId) {
			
			const currentDesignEl = document.querySelector(`.option-item[data-design-id="${designId}"]`);
			const currentDesignId = currentDesignEl?.dataset?.designId;
			if (currentDesignId) {

				loadUnitMoqProductPreview(currentDesignId);
			
				$(`.option-item[data-design-id="${currentDesignId}"] label`).click();
				$(`.option-item[data-design-id="${currentDesignId}"] input`).prop('checked', true);
			}
		}
		else if (variantId) {
			$('.color-options-more').click();
			
			loadUnitMoqProductPreview(variantId);

			const $option = $(`.option-item[data-variant-id="${variantId}"]`);
			$option.find('input').prop('checked', false);
			$option.find('label').click();
			if ($option.is('.is-rts')) {
				$('.color-options-more').click();
			}
		}
	}

	const renderItems = () => {
		const isPDP = document.querySelector('.product');
		umoq = window.UnitMOQ;
		umoqSession = umoq?.beta?.session;
		savedDesigns = umoqSession?.getDesigns();
		const currentDesign = savedDesigns?.find(design => design?.design_id == designId);
		let currentProductDesigns = "";
		urlParams = new URLSearchParams(window.location.search);
		designId = urlParams.get('design');
		$(".saved-designs-drawer__item").remove();
		savedDesigns?.forEach(design => {
			const sessionMetadata = design?.session_metadata || design?.sessionMetadata;
			const link = sessionMetadata?.addToCart+design?.design_id || `${window.location.origin}/products/${prodObj.handle}?design=${design.design_id}`;
			const name = sessionMetadata?.designName || design.name.replace(/^Custom\s+/i, '');
			const price = `$${(design.price / 100).toString().replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1')}`;
			const dataString = JSON.stringify(design)?.replace(/"/g, '&quot;');
			const isSelected = currentDesign?.design_id === design.design_id;
			const color = design.options[0].label;
			$(".saved-designs-drawer__panel").append(`
				<div class='saved-designs-drawer__item' data-saved-product-design-id='${design.design_id}'>
					<a class='saved-designs-drawer__item-media' href='${link}' aria-label='View ${name}'>
						<img class='saved-designs-drawer__item-image' src='${design.image_url}' alt='${name}'/>
					</a>
					<div class='saved-designs-drawer__item-detail'>
					<a class='saved-designs-drawer__item-title' href='${link}' aria-label='View ${name}'>${name}</a>
					<div class='saved-designs-drawer__item-price'>Designed at ${price}</div>
						<a class='saved-designs-drawer__item-btn' href='${link}' aria-label='View Design'>View Design</a>
						<a class='saved-designs-drawer__item-btn saved-designs-drawer__item-btn--alt' onclick='GorgiasChat.open();' aria-label='View Expert&lsquo;s Advice'>Expert&lsquo;s Advice</a>
					</div>
					<button class='saved-designs-drawer__item-remove' aria-label='Remove Item'></button>
				</div>
			`);
			if (productId && sessionMetadata?.productId == productId) {
				currentProductDesigns += `
					<div class="option-item is-design${isSelected ? ' is-selected' : ''}" data-ATC="${sessionMetadata?.addToCart}${design.design_id}" data-design-id="${design.design_id}" data-sku="${design.design_id}"> 
						<svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path> </svg>
						<input type="radio" id="template--${productId}__custom-${design.design_id}" name="Color" value="${color}" form="product-form-template--${productId}__main">
						<label design-data="${dataString}" data-price="${price}" data-ATC="${sessionMetadata?.addToCart}${design.design_id}" style="background-image:url(${design.image_url});" data-color="${color}" class="color-swatch variant-swatch round" for="template--${productId}__custom-${design.design_id}">
							<span class="visually-hidden">Custom Design</span>
						</label>
					</div>
				`;
			}
		});
		if (isPDP && currentProductDesigns !== "") {
			$(".design-options-container")?.html(currentProductDesigns);
			$('.designs-label')?.addClass('shown');
		}
		if ($(".saved-designs-drawer__item").length) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--empty");
		} else {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active").addClass("saved-designs-drawer--empty");
		}
		handleDeeplinkingToDesign();
	}

	$(".saved-designs-drawer").on("click", ".saved-designs-drawer__item-remove", function (e) {
		e.preventDefault();
		const item = $(this).parents(".saved-designs-drawer__item"),
			itemId = item.attr('data-saved-product-design-id'),
			variantEl = document.querySelector(`.option-item[data-design-id="${itemId}"]`);
		umoqSession.removeDesign(itemId);
		if (!document.querySelectorAll('.option-item.is-design').length) {
			$('.designs-label')?.removeClass('shown');
			$('.saved-designs-drawer')?.addClass('saved-designs-drawer--empty');
		}
		if (variantEl) {
			variantEl.remove();
		}
		item.remove();
	});

	$(".saved-designs-drawer__tab").on("click", function () {
		if ($(".saved-designs-drawer").hasClass("saved-designs-drawer--active")) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
			$("body").removeClass("saved-designs-drawer--active");
		} else {
			$(".saved-designs-drawer").addClass("saved-designs-drawer--active");
			$("body").addClass("saved-designs-drawer--active");
		}
	});

	// JRH Update (03/23/26) - Listen for EVENT_DESIGN_LOADED instead of EVENT_LOADED for quicker UI.
	window.UnitMOQ.on(window.UnitMOQ.EVENT_DESIGN_LOADED, (e) => {
		renderItems();
		$('.variant-loader').hide();
		$('.gallery-wrap').removeClass('hidden');
		$('.gallery-image').addClass('hidden');
	});

	window.UnitMOQ.on(window.UnitMOQ.EVENT_SAVED, (e) => {
		renderItems();
	});

	// const allEventObjects = Object.entries({...window.UnitMOQ, ...window.UnitMOQ?.beta?.session}).filter(([key]) => key.startsWith('EVENT_'));
	// allEventObjects.forEach(([key, value]) => {
	// 	const eventParent = value.includes('-session-') ? window.UnitMOQ?.beta?.session : window.UnitMOQ;
	// 	eventParent?.on(value, (e) => {
	// 		console.log(key, value);
	// 	});
	// });

	window.UnitMOQ.beta.session.on(window.UnitMOQ.beta.session.EVENT_DESIGN_ADDED, (data) => {
		const design = data?.detail;
		prodObj = $('.product')?.data('obj');
		if (design) {
			//replace variant with design in url without reloading the page
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set('design', design?.design_id);
			urlParams.delete('variant');
			window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
			renderItems(); 
		}
	});

	$('.product #umoq-save-btn').on('click', function (e) {
		e.preventDefault();
		const $btn = $(this);
		const original = $btn.text();
		$btn.prop('disabled', true).text('Saving…');
		prodObj = $('.product')?.data('obj');
		umoqSession.setSessionMetadata({
			productId: prodObj?.productId,
			designName: prodObj?.productTitle,
			addToCart: `${window.location.origin}/products/${prodObj?.productHandle}?design=`
		});
		$.when(umoq.savePreview()).always(function (designObj) {
			$btn.prop('disabled', false).text(original);
		});
	});

	renderItems();
}
savedDesignsInit();